import React from "react";
import { Reveal } from "../ui/Reveal";
type Props = {
  eyebrow: string;
  title: string;
  lead: string;
  children: React.ReactNode;
  footer: React.ReactNode;
};

/** Shared split layout for client login and registration. */
export function AuthShell({
  eyebrow,
  title,
  lead,
  children,
  footer
}: Props) {
  return <section className="relative overflow-hidden" data-id="element-46" data-mp="8pv65ot0qxko">
      <div className="grid-lines pointer-events-none absolute inset-0" aria-hidden data-id="element-47" data-mp="8n8vvhequ3yr" />
      <div className="blue-glow pointer-events-none absolute inset-0" aria-hidden data-id="element-48" data-mp="15ejgs02enik2" />
      <div className="shell relative grid min-h-[calc(100vh-84px)] items-center gap-[clamp(2.5rem,5vw,7rem)] py-[clamp(3rem,6vw,7rem)] lg:grid-cols-2" data-id="element-49" data-mp="11e93s3g73rvp">
        <Reveal data-id="element-50" data-mp="rftk2ljhzkw8">
          <p className="t-eyebrow mb-6 flex items-center gap-3 text-accent-soft" data-id="element-51" data-mp="rgcsnbn9cwxl"><span className="h-1.5 w-1.5 rounded-full bg-accent" data-id="element-52" data-mp="3h4vmjliwchsk" />{eyebrow}</p>
          <h1 className="t-h1 max-w-[14ch]" data-id="element-53" data-mp="3h2sms9rxzaan">{title}</h1>
          <p className="t-lead mt-6 max-w-[44ch] text-fg-2" data-id="element-54" data-mp="3c4r3bnqlt8yn">{lead}</p>
        </Reveal>
        <Reveal delay={0.05} className="w-full max-w-[560px] justify-self-center lg:justify-self-end" data-id="element-55" data-mp="1b22758kcemhd">
          <div className="rounded-[clamp(1rem,1.5vw,1.75rem)] border border-line bg-ink-2/90 p-[clamp(1.5rem,3vw,3rem)] backdrop-blur" data-id="element-56" data-mp="1f470e66vph3h">
            {children}
          </div>
          <div className="mt-6 text-center text-[15px] text-muted" data-id="element-57" data-mp="162z0xksmma7t">{footer}</div>
        </Reveal>
      </div>
    </section>;
}